//#region src/generated/locales/en.ts
var templates = {
	"pd.order.contacts.billingContact.inputHeader": `Billing Address`,
	"pd.order.contacts.orderContact.inputHeader": `Address`,
	"pd.order.contacts.propertyContact.checkBox": `Is the customer a landlord?`,
	"pd.order.summary.agree.link1": `I accept the`,
	"pd.order.summary.agree.link2": `Terms and Conditions`,
	"pd.order.summary.agree.required": `Please agree to the terms and conditions to proceed.`,
	"pd.order.summary.billing": `Invoice`,
	"sa84bab91f8a49fe3": `Kundenadresse als Rechnungsadresse verwenden`,
	"s1d1be881bd7dd5f6": `Rechnungsadresse entspricht der Kundenadresse.`,
	"s6c2e8c3fd63326fa": `Neue Rechnungsadresse hinzufügen`,
	"s6cfee04ec1ab2f22": `Adresse der Immobilie`,
	"se253c48907431e1f": `Adresse der Verwaltung (optional)`,
	"sa9bdcc9d5a643bb8": `Kundenadresse als Verwaltungsadresse verwenden`,
	"sec4bd3f10d0782bd": `Verwaltungsadresse entspricht der Kundenadresse.`,
	"se52f82757214a82b": `Neue Verwaltungsadresse hinzufügen`,
	"sdd2fffdf86bf5b6e": `Adresse`,
	"s5c9229e6891b5b83": `Rechnungsadresse`,
	"se1b4ea2cbb1f9bb4": `Immobilie`,
	"s3be4da85df39b1c2": `Verwaltung`
};
//#endregion
export { templates };
